import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";

import { FileTreeNode } from "../../../fileTreeHelpers";

const LastCommitCell = ({ item, ...cellProps }: TableSimpleCellProps<FileTreeNode>) => {
  if (item.type === "parent") {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellEmpty />
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      {item.file?.commit.message ? (
        <TableCellText>{item.file.commit.message}</TableCellText>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default LastCommitCell;
